import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { fetchReset } from '../../actions/fetch.actions';
import FileUpload from '../../components/core/FileUpload';
import { INPUT_STATES } from '../../components/forms/forms.utils';
import SelectField from '../../components/forms/SelectField';
import TextField from '../../components/forms/TextField';
import { TEMPLATE_CATEGORIES_OPTIONS } from '../../constants/templates.constants';
import { useForm } from '../../hooks/useForm.hook';
import { ADMIN_TEMPLATES_RESOURCE } from '../../resources/admin/admin.templates.resource';
import templatesService from '../../services/api/templates.service';
import Modal from '../Modal';
import ModalTitle from '../ModalTitle';

const INPUT_NAME = 'spo-add-template-textfield';

const AddTemplateModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const modalContentRef = useRef(null);
  const { data, isSubmitting, input, submitStart, submitOk, submitError, error } = useForm({
    name: '',
    category: '',
    file: ''
  });

  const handleConfirm = () => {
    submitStart();
    templatesService.add(
      { ...data },
      {
        onSuccess: () => {
          submitOk();
          dispatch(fetchReset(ADMIN_TEMPLATES_RESOURCE));
          handleClose();
        },
        onError: (message) => submitError(message)
      }
    );
  };

  const handleClose = () => {
    Object.keys(data).forEach((key) => {
      input('', `${key}`);
    });

    onClose();
  };

  const handleFileAdd = (files) => {
    input(files[0], 'file');
  };

  const handleFileDelete = () => {
    input(null, 'file');
  };

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => {
        document.getElementsByName(INPUT_NAME)?.[0]?.focus();
      }, 10);
    }
  }, [isOpen]);

  return (
    <Modal
      ref={modalContentRef}
      className="spo-o-add-template-modal"
      title={<ModalTitle hasError={!!error} title="Sjabloon toevoegen" />}
      isOpen={isOpen}
      onClose={handleClose}
      onConfirm={handleConfirm}
      canConfirm={!!data?.name && !!data?.category && !!data?.file}
      isSubmitting={isSubmitting}
      onConfirmLabel="Toevoegen"
      onConfirmIcon="ai-check-1"
    >
      <TextField
        label="Naam"
        name={INPUT_NAME}
        value={data.name}
        state={INPUT_STATES.DEFAULT}
        onChange={(value) => input(value, 'name')}
        disabled={isSubmitting}
      />
      <SelectField
        id="add-template-modal-category"
        label="Categorie"
        name={'category'}
        required
        onChange={(value) => input(value, 'category')}
        options={TEMPLATE_CATEGORIES_OPTIONS}
        parentElement={modalContentRef.current}
        value={data.category}
        className="u-margin-top"
        disabled={isSubmitting}
      />
      <div className="u-margin-top-lg">
        <FileUpload
          required
          files={data.file ? [data.file] : []}
          onChange={handleFileAdd}
          onDelete={handleFileDelete}
        />
      </div>
      {!!error && <p className="u-margin-top u-text-danger">{error}</p>}
    </Modal>
  );
};

export default AddTemplateModal;
